export type NavigationItem = {
  label: string;
  href: string;
  description: string;
};

export const primaryNavigation: NavigationItem[] = [
  { label: "Product", href: "/product", description: "Agentic Plus capabilities" },
  { label: "How it works", href: "/how-it-works", description: "The growth mission workflow" },
  { label: "Use cases", href: "/use-cases", description: "Marketing scenarios" },
  { label: "FAQ", href: "/faq", description: "Scope and governance answers" },
  { label: "About", href: "/about", description: "Company overview" },
  { label: "Contact", href: "/contact", description: "Request a demo" },
];

export const footerNavigation = [
  {
    title: "Product",
    links: [
      { label: "Product overview", href: "/product" },
      { label: "How it works", href: "/how-it-works" },
      { label: "Use cases", href: "/use-cases" },
      { label: "FAQ", href: "/faq" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "/about" },
      { label: "Contact", href: "/contact" },
      { label: "Security", href: "/security" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms of Service", href: "/terms" },
      { label: "Sitemap", href: "/sitemap.xml" },
    ],
  },
];
